module.exports = __webpack_public_path__ + "img/cpzs.121d89f7.png";